var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draw-debug",style:(("--x: " + (_vm.pos.x) + "px; --y: " + (_vm.pos.y) + "px;"))})}
var staticRenderFns = []

export { render, staticRenderFns }